@if (label) {
  <div class="mb-2">
    <span class="font-semibold" data-test-id="service-provider-search-label">{{ label }}</span>
  </div>
}

<form [formGroup]="searchForm">
  <div class="flex gap-4 items-center">
    <div class="flex gap-4 items-center">
      <label class="label font-semibold field-required" data-test-id="npi-label">Search Service Provider by NPI:</label>
      <p-input-mask
        slotChar=""
        mask="999999999999"
        [maxlength]="12"
        formControlName="searchText"
        placeholder="Enter the NPI"
        [autoClear]="false"
        data-test-id="npi-value"
      ></p-input-mask>
    </div>
    <button
      pButton
      type="submit"
      label="Search"
      icon="pi pi-search"
      [loading]="isLoading"
      (click)="searchNPI()"
      [disabled]="!searchForm.valid"
      data-test-id="npi-search-button"
    ></button>
  </div>
  @if (isProviderNotFound) {
    <div>
      <div class="mb-4">
        <p class="text-red-400 font-semibold py-4" data-test-id="npi-search-error">
          Service Provider Not found.
        </p>
        </div>
        @if (isProviderNotFound && authRequest) {
          <div class="mt-4">
            <div class="flex items-center">
              <p-checkbox
                inputId="npiNotFoundCheck"
                binary="true"
                (onChange)="updateStatus($event)"
                [formControl]="npiCheck"
                data-test-id="npi-not-found-checkbox"
              ></p-checkbox>
              <label for="npiNotFoundCheck" class="ml-2">NPI was not found. Click checkbox and enter service location to continue.</label>
            </div>
          </div>
        }
      </div>
    }
  </form>
